import { Group, Menu, Text } from '@mantine/core';
import { openModal } from '@mantine/modals';
import { IconKey, IconLogout, IconUserCircle } from '@tabler/icons-react';

import useAuth from '@hooks/useAuth';

import EditUserPasswordForm from '@components/EditUserPasswordForm';

import logo from '@assets/images/logo.png';

import classes from './Header.module.css';

export default function Header() {
  const { logout } = useAuth();
  const handleEditPasswordClick = () => {
    openModal({
      title: 'Modifica password',
      children: <EditUserPasswordForm />,
    });
  };
  return (
    <header className={classes.header}>
      <Group justify="space-between">
        <img src={logo} alt="Logo Ieis" className={classes.logo} />

        <Group>
          <Menu withArrow>
            <Menu.Target>
              <IconUserCircle size="2rem" />
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item onClick={handleEditPasswordClick}>
                <Group>
                  <IconKey size="1.5rem" />
                  <Text size="sm">Modifica password</Text>
                </Group>
              </Menu.Item>
              <Menu.Item onClick={logout} c="red">
                <Group>
                  <IconLogout size="1.5rem" />
                  <Text size="sm">Logout</Text>
                </Group>
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>
      </Group>
    </header>
  );
}
